/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { useState, useEffect, useRef } from 'react';
import { Box, Typography, Grid, Button, Paper } from '@mui/material';
import UserAvatarComponent from 'components/UserAvatarComponent';
import { socket } from '../../socket';
import { htmlContent, urlify, convertDateAndTime } from 'Helpers';

const MiniPost = ({ post, setSelected, setOpenViewer }) => {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const [showMoreBtn, setShowMoreBtn] = useState(false);
    const [showMore, setShowMore] = useState(false);
    const [reactCount, setReactCount] = useState(parseInt(post.postReactCount));

    useEffect(() => {
        listen_to_channel();
    }, []);

    function listen_to_channel() {
        socket.on('post_mini_react_added', (post_id) => {
            if (post_id == post.post_id) {
                setReactCount((prev) => prev + 1);
            }
        });
        socket.on('post_mini_react_removed', (post_id) => {
            if (post_id == post.post_id) {
                setReactCount((prev) => prev - 1);
            }
        });
    }

    // Determine if the body is long enough to show the button
    useEffect(() => {
        if (post && post.plain_text_body && urlify(post.plain_text_body).length > 100) {
            setShowMoreBtn(true);
        } else {
            setShowMoreBtn(false);
        }
    }, [post]);

    return (
        <Paper
            elevation={0}
            sx={{
                marginBottom: '16px',
                padding: '20px',
                borderRadius: '12px',
                border: '1px solid #1E7C8840',
                backgroundColor: '#ffffff',
                transition: 'all 0.2s ease-in-out',
                cursor: 'pointer'
            }}
        >
            <Box
                display="flex"
                gap="12px"
                sx={{
                    position: 'relative',
                    alignItems: { lg: 'flex-start', md: 'flex-start', xs: 'flex-start' },
                    marginBottom: '16px'
                }}
            >
                <Box sx={{ flexShrink: 0 }}>{post.user && <UserAvatarComponent userData={post.user} />}</Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', width: '100%', gap: '5px' }}>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography
                            variant="subtitle1"
                            sx={{
                                fontSize: '15px',
                                fontWeight: '600',
                                color: '#1a1a1a',
                                marginBottom: '4px',
                                lineHeight: '1.2'
                            }}
                        >
                            {`${post.user?.first_name} ${post.user?.last_name}`}
                        </Typography>
                        <Box display="flex" sx={{ flexDirection: 'column', gap: '2px' }}>
                            <Typography
                                variant="body2"
                                sx={{
                                    fontSize: '13px',
                                    color: 'rgba(0, 0, 0, 0.6)'
                                }}
                            >
                                {`${post.user.job_title ? post.user.job_title[0]?.title : 'N/A'}`}
                            </Typography>
                        </Box>
                    </Box>
                    <Typography
                        variant="body2"
                        sx={{
                            color: 'rgba(0, 0, 0, 0.5)',
                            fontSize: '12px',
                            fontWeight: '400'
                        }}
                    >
                        {convertDateAndTime(post.createdAt, false)}
                    </Typography>
                </Box>
            </Box>

            <Box sx={{ marginBottom: '16px' }}>
                {showMoreBtn ? (
                    <Box>
                        <Typography
                            variant="body2"
                            sx={{
                                fontSize: '14px',
                                lineHeight: '1.5',
                                color: '#333'
                            }}
                        >
                            {showMore ? urlify(post.plain_text_body) : `${urlify(post.plain_text_body).substring(0, 100)}...`}
                            {!showMore ? (
                                <Button
                                    sx={{
                                        fontSize: '13px',
                                        textTransform: 'none',
                                        padding: 0,
                                        minWidth: 'auto',
                                        marginLeft: '4px',
                                        color: '#1E7C88'
                                    }}
                                    onClick={() => setShowMore(true)}
                                >
                                    View more
                                </Button>
                            ) : (
                                <Button
                                    sx={{
                                        fontSize: '13px',
                                        textTransform: 'none',
                                        padding: 0,
                                        minWidth: 'auto',
                                        marginLeft: '4px',
                                        color: '#1E7C88'
                                    }}
                                    onClick={() => setShowMore(false)}
                                >
                                    View less
                                </Button>
                            )}
                        </Typography>
                    </Box>
                ) : (
                    <Typography
                        variant="body2"
                        sx={{
                            fontSize: '14px',
                            lineHeight: '1.5',
                            color: '#333'
                        }}
                    >
                        {urlify(post.plain_text_body)}
                    </Typography>
                )}
            </Box>

            <Box
                display="flex"
                alignItems="center"
                gap="16px"
                sx={{
                    paddingTop: '12px'
                }}
            >
                <Typography
                    sx={{
                        fontSize: '13px',
                        fontWeight: '500',
                        color: '#1E7C88',
                        marginLeft: 'auto',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        cursor: 'pointer',
                        border: '1px solid #1E7C88',
                        borderRadius: '50px',
                        backgroundColor: 'rgba(30, 124, 136, 0.08)',
                        padding: '4px 12px',
                        '&:hover': {
                            color: '#1E7C88',
                            backgroundColor: 'rgba(30, 124, 136, 0.03)',
                            borderColor: '#1E7C88',
                            transition: 'all 0.2s ease-in-out'
                        }
                    }}
                    onClick={() => {
                        setSelected(post);
                        setOpenViewer(true);
                    }}
                >
                    View Post
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7 17L17 7M17 7H7M17 7V17"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </Typography>
            </Box>
        </Paper>
    );
};

export default MiniPost;
